import { Divider } from "antd";
import React from "react";

const CustomDivider = ({ className, dashed, orientation, orientationMargin, children }) => {
  return (
    <Divider
      className={className || "my-2"}
      dashed={dashed}
      orientation={orientation}
      orientationMargin={orientationMargin}
    >
      {children}
    </Divider>
  );
};

export default CustomDivider;
